/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetHospitalQueryResponse,
  GetHospitalPathParams,
  GetHospital404,
} from '../types/GetHospital'

function getGetHospitalUrl({
  hospital_id,
}: {
  hospital_id: GetHospitalPathParams['hospital_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/hospital/${hospital_id}/` as const,
  }
  return res
}

/**
 * @summary Get hospital detail
 * {@link /api/v1/hospital/:hospital_id/}
 */
export async function getHospital(
  { hospital_id }: { hospital_id: GetHospitalPathParams['hospital_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetHospitalQueryResponse,
    ResponseErrorConfig<GetHospital404>,
    unknown
  >({
    method: 'GET',
    url: getGetHospitalUrl({ hospital_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
